// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_oz5","cls2":"LoswpExitIntentModal-cls2_UJ2 LoswpExitIntentModal-cls1_oz5"};